<template>
  <div class="container-busca">
    
    <div class="row">
        <div class="col-sm-12">
      <h2 class="d-none d-sm-block">Lista de propostas</h2>
      <h4 class="d-block d-sm-none">Lista de propostas</h4><br>
    </div>

      <router-link v-if="getPermissao() == 1" to="/criarProposta" class="col-sm-3  btn btn-warning">+ Criar Nova</router-link> 
<!--<a target="_blank" :href="'https://www2.royaljardim.com.br/sistema/leads/exportacao'" v-if="getPermissao() == 1" class="col-sm-3  btn btn-warning d-none d-sm-block ml-3">IMPORTAR LEADS</a> -->

      <div class="col-sm-12"><br></div>




<form class="row" method="POST" ref="formulario" @submit.prevent.stop="buscar">

  <div class="form-group col-sm-3">
          <label>Data:</label>
             <Datepicker @reset="resetarData" show-clear-button placeholder="De - Até" range v-model="selectedDate" lang="pt-br" date-format="formato"/>
        </div>
  

 <div class="form-group col-sm-2 d-none d-sm-block">
        <label>Status:</label>
        
        <select class="form-control" name="status" v-model="status">
           <option value="">Selecione</option>
        <option value="Pendente">Aguardando</option>
            <option value="Assinado">Assinado</option>
    </select>
  </div>

          <div class="form-group col-sm-3">
          <label>Nome:</label>
          <input type="text" name="nome" class="form-control" value="" v-model="nome">
        </div>
  

         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Referência:</label>
           <input type="text" name="fonte" class="form-control"  v-model="fonte" />
        </div>

        
<div class="form-group col-sm-4">
          <label>Edificio:</label>
          <AutocompleteCustom ref="autocomplete" :resultados.sync="matchesEdificio" :nome.sync="edificioSelecionado" @pronto="addEdificio" url="autocompleteEdificios" classe="autocompleteEdificios"></AutocompleteCustom>
          
        </div>


          <button ref="buscar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:30px;">BUSCAR</button>
           <button  class="btn btn-danger col-sm ml-1" @click="limpar" type="button"  style="max-height:40px;margin-top:30px;">LIMPAR</button>

       </form>

    </div><!-- row -->

    <div class="row">
   <div class="col-12"><br>
   
  </div><!-- col -->
</div><!-- row -->


    <div class="row">

       <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

<br>
<div class="table-responsive">
 <table class="col-sm table  ">
  <thead>
    <tr>
      <th scope="col">Referência</th>
       <th scope="col">Entrada</th>
       <th scope="col">Atualização</th>
      <th scope="col">Nome</th>
      <th scope="col">Edificio</th>
      <th scope="col">Assinado</th>
          
        <th scope="col">Corretor</th>
       <th scope="col"></th>
         <th scope="col">Link</th> 
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in leads" :key="item.PROP_ID" :class="{'destacado':item.PROP_PREENCHIDO == 'Sim'}">
     
      <td >{{item.PROP_IMOVEL}}</td>
       <td >{{item.PROP_DATA}}</td>
      <td >{{item.PROP_ATUALIZACAO}}</td>
      <td >{{item.PROP_NOME}}</td>
      <td>{{item.ED_NOME}}</td>
     
       <td >
           {{item.PROP_PREENCHIDO}}
       </td>
     
       
     <!-- <td >{{item.LOG_NOME}}</td> -->
       <td >
         
         
            <select v-if="getPermissao() == '1'" class="form-control combo-corretores" ref="comboCorretores" name="corretor" style="width:150px;" v-model="item.LOG_ID" @change="trocarCorretor(item.PROP_ID,$event)">
            <option value="">Selecione</option>
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_ID">{{user.LOG_NOME}}</option>
            </select>
        
       </td>
      <td>
      <a target="_blank" :href="'https://www2.royaljardim.com.br/site/proposta/' + item.PROP_ID" v-if="getPermissao() == 1" class="btn btn-sm btn-info">VISUALIZAR</a> 
     
      </td>
      <td> <button class="btn btn-sm btn-warning" @click="copiarLink(item.PROP_ID)">Copiar</button></td> 

     

    </tr>
   
  </tbody>
</table>
</div>
<div class="col-sm-4 offset-sm-4">
   <div  v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:15px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
 <button @click="paginar" ref="paginar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:10px;">MAIS RESULTADOS</button>
       
 </div>
    </div><!-- row table -->



  </div>
</template>
<style>
.destacado{background:#ffff77 !important;}
</style>
<script>
import axios from 'axios'

import AutocompleteCustom from '@/components/AutocompleteCustom'

import 'vue-popperjs/dist/vue-popper.css';

export default {
  name: 'Propostas',
  components: {AutocompleteCustom},
  
  data(){
      return {
         usuarios:[],
         selectedEdificio:null,
        edificioSelecionado:'',
             matchesEdificio:[],
        ocultar:true,
        fonte:'',
        telefone:'',
        bairroSelecionado:'',
        selectedBairro:'',
         matches:[],
        metragem:null,
        metragem2:null,
        formato:{day: '2-digit',month: '2-digit',year: 'numeric' },
        selectedDate:[],
        referencia:'',
        status:'',
       nome:'',
          leads:[],
          loading: false,
          valor:'',
          valor2:'',
          
          money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false,
            
             
          }
      }
  },
 

methods:{
  buscaRapida(){
    this.status = "Pendente";
    const elem = this.$refs.buscar;
    elem.click();
   
  },
    trocarStatus(id,event){
   
      let fm = new FormData();
      fm.append('id',id);
      fm.append('status',event.target.value);
      this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/trocarStatus',fm)
          .then(response => console.log(response))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
  },
  trocarCorretor(id,event){
   
      let fm = new FormData();
      fm.append('id',id);
      fm.append('corretor',event.target.value);
      this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/propostas/trocarCorretor',fm)
          .then(response => console.log(response))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
  },
    getUsuarios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getUsuarios',{})
          .then(response => this.usuarios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
  copiarLink(data){
    
   
       window.navigator.clipboard.writeText("https://www2.royaljardim.com.br/site/proposta/"+data).then(() => {
        console.log('Content copied to clipboard');
        /* Resolved - text copied to clipboard successfully */
      },() => {
        console.error('Failed to copy');
        /* Rejected - text failed to copy to the clipboard */
      });
  },
  getHistorico(id){
     axios
          .post('https://www2.royaljardim.com.br/sistema/leads/getHistorico/'+id)
          .then(response => {
            if(response.data.length > 0)
              window.$('#pop'+id).text(response.data[0].HI_TEXTO)
            })
          .catch(response => console.log(response))
          
  },
  paginar(){
    this.loading = true;
          let fm = null;

          
            fm = new FormData(this.$refs["formulario"]);
          
            fm.append('permissao',this.getPermissao());
            fm.append('corretor',this.getUsuario());
             
             fm.append('edificio',this.selectedEdificio);
             fm.append('paginacao',this.leads.length);
           
           
              

            if(this.selectedDate.length > 0){
              let dd = Number(this.selectedDate[0].getDate());
              let mm = Number(this.selectedDate[0].getMonth() + 1);
              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;
              let de = this.selectedDate[0].getFullYear() + "-" + mm + "-" + dd + " 00:00";

              let dd2 = Number(this.selectedDate[1].getDate());
              let mm2 = Number(this.selectedDate[1].getMonth() + 1);
              if (dd2 < 10) dd2 = '0' + dd2;
              if (mm2 < 10) mm2 = '0' + mm2;
              let ate = this.selectedDate[1].getFullYear() + "-" + mm2 + "-" + dd2 + " 23:59";

               fm.append('de',de);
               fm.append('ate',ate);
            }

        
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/busca',fm)
          .then( response => {console.log(response); response.data.forEach( lead => this.leads.push(lead) );})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    
  },
   addEdificio(valor){
      this.selectedEdificio = valor.ED_ID;
     
    },
    getEdificio(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getEdificio',{id:this.selectedEdificio})
          .then(response => {this.edificioSelecionado = response.data.ED_NOME;
           this.$refs.autocomplete.preencher(response.data.ED_NOME);})
          .catch(response => console.log(response))
          
    },
  addBairro(valor){
      this.selectedBairro = valor.BAI_ID;
      
    },
  resetarData(){
    this.selectedDate = [];
  },
  limpar(){
        
           this.referencia = '',
           this.status = ''
            this.nome = '';
            
              this.selectedEdificio = null;
              this.selectedDate = [];
              
                 this.fonte = '';
               
  },
  salvarFiltros(){
    return {
         
          leads: this.leads,
          loading: this.loading,
          valor:this.valor,
          valor2: this.valor2,
         
           referencia:this.referencia,
            status:this.status,

    }
  },

    get(){
       let fm = new FormData();
       fm.append('permissao',this.getPermissao());
      fm.append('corretor',this.getUsuario());
        fm.append('paginacao',0);

          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/propostas/getPropostas',fm)
          .then(response => {this.leads = response.data;console.log(response)})
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    buscar(){
     
          this.loading = true;
          let fm = null;

          
            fm = new FormData(this.$refs["formulario"]);
           
            fm.append('permissao',this.getPermissao());
            fm.append('corretor',this.getUsuario());
          
             fm.append('edificio',this.selectedEdificio);
             fm.append('paginacao',0);
             
           
              

            if(this.selectedDate.length > 0){
              let dd = Number(this.selectedDate[0].getDate());
              let mm = Number(this.selectedDate[0].getMonth() + 1);
              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;
              let de = this.selectedDate[0].getFullYear() + "-" + mm + "-" + dd + " 00:00";

              let dd2 = Number(this.selectedDate[1].getDate());
              let mm2 = Number(this.selectedDate[1].getMonth() + 1);
              if (dd2 < 10) dd2 = '0' + dd2;
              if (mm2 < 10) mm2 = '0' + mm2;
              let ate = this.selectedDate[1].getFullYear() + "-" + mm2 + "-" + dd2 + " 23:59";

               fm.append('de',de);
               fm.append('ate',ate);
            }

        
          axios
          .post('https://www2.royaljardim.com.br/sistema/propostas/busca',fm)
          .then( response => {console.log(response);this.leads = response.data;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
          
          
         
    },

   
     filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".");
    },
    getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }

},
  
  mounted() {
    this.getUsuarios();
    this.get();
     
  }



}
</script>